import { Helmet } from 'react-helmet-async';
// @mui
import { Container } from '@mui/material';
// routes
import { PATH_MASTERDATA } from '../../../routes/paths';
// components
import { useSettingsContext } from '../../../components/settings';
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs';
// sections
import SiteNewEditForm from 'src/sections/@dashboard/sites/SiteNewEditForm';

// ----------------------------------------------------------------------

export default function SiteAddPage() {
    const { themeStretch } = useSettingsContext();

    return (
        <>
            <Helmet>
                <title> User: Create a new user</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'lg'}>
                <CustomBreadcrumbs
                    heading="Create a new site"
                    links={[
                        { name: 'Master Data', href: PATH_MASTERDATA.root },
                        { name: 'Site', href: PATH_MASTERDATA.site },
                        { name: 'New site' },
                    ]}
                />
                <SiteNewEditForm />
            </Container>
        </>
    );
}
